import { useMutation } from '@tanstack/react-query';

import {
  getWebpunchLink,
  webPunchLinkConfigure,
} from '../../../api/endpoints/support/webpunch';
import { IErrorResponse } from '../../../api/interfaces';
import { IWebPunchLink } from '../../../api/interfaces/support/webpunch';

export const useGetWebpunchLink = () => {
  const {
    mutateAsync: getWebPunch,
    isPending: isLoading,
    data: { data: webpunch } = {},
  } = useMutation<
    {
      [x: number]: string;
      data: IWebPunchLink;
    },
    IErrorResponse,
    string
  >({
    mutationFn: (foreignId) => getWebpunchLink(foreignId),
  });

  return {
    getWebPunch,
    webpunch,
    isLoading,
  };
};

export const useUpdateWebpunch = () => {
  const {
    mutateAsync: updateWebpunch,
    isPending: isLoading,
    data: { data: updatedWebpunch } = {},
  } = useMutation<
    {
      [x: number]: string;
      data: IWebPunchLink;
    },
    IErrorResponse,
    { unitId: string; integrationKeyId: string }
  >({
    mutationFn: ({ unitId, integrationKeyId }) =>
      webPunchLinkConfigure(unitId, integrationKeyId),
  });

  return {
    updateWebpunch,
    updatedWebpunch,
    isLoading,
  };
};
